import { render, staticRenderFns } from "./OccurrenceNature.vue?vue&type=template&id=61c9e1fc"
import script from "./OccurrenceNature.vue?vue&type=script&lang=js"
export * from "./OccurrenceNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports